// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  appVersion: require('../../package.json').version + '-dev',
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyCt4UnOOmkIgTUJjBc3RNvL5rUoJY1vIW4",
    authDomain: "auctionware-6eb5b.firebaseapp.com",
    projectId: "auctionware-6eb5b",
    storageBucket: "auctionware-6eb5b.appspot.com",
    messagingSenderId: "204899043551",
    appId: "1:204899043551:web:e2ab4e7f560925080d816a",
    measurementId: "G-P0Z74GH08G"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
